import React from 'react';

/** Infinite horizontal marquee (content duplicated for a seamless loop; pauses on hover). */
export default function Marquee({ children, className = '', duration = 40, reverse = false, pauseOnHover = true }) {
  return (
    <div className={`group/marquee relative flex overflow-hidden ${className}`}>
      {[0, 1].map((copy) => (
        <div
          key={copy}
          aria-hidden={copy === 1 ? 'true' : undefined}
          // React 18 has no `inert` prop typing; a string attribute keeps the clone unfocusable.
          inert={copy === 1 ? '' : undefined}
          className={`flex min-w-full shrink-0 animate-marquee items-center justify-around gap-3 pr-3 ${pauseOnHover ? 'group-hover/marquee:[animation-play-state:paused]' : ''}`}
          style={{ animationDuration: `${duration}s`, animationDirection: reverse ? 'reverse' : 'normal' }}
        >
          {children}
        </div>
      ))}
    </div>
  );
}
